import { ref, Ref, watch } from "vue";
import Konva from "konva";
import Shape = Konva.Shape;
import Transformer = Konva.Transformer;

const useMoveAndSelection = (
  stage: Ref<Konva.Stage | null>,
  layer: Ref<Konva.Layer | null>,
  enable: Ref<boolean>
) => {
  const activeShapes = ref<Shape[]>([]);
  let transformer: Transformer | null = null;
  watch(
    [stage, layer],
    ([stage, layer]) => {
      if (!stage || !layer) return;
      // 1. 准备一个变换选择器（选中之后可以拖拽，变形）
      transformer = new Konva.Transformer({
        keepRatio: true,
      });
      layer.add(transformer);

      stage.on("tap click", function (e) {
        if (!enable.value) return;
        // 点击空白区域或不能拖拽的元素，则清空选中
        if (e.target instanceof Konva.Stage || !e.target.draggable()) {
          transformer?.nodes([]);
          activeShapes.value = [];
          return;
        }
        if (e.target.hasName("_anchor")) {
          // 避免点击锚点时触发选中抛出Maximum Call Stack Exceeded Error
          return;
        }
        // 点击形状，则选中
        const shape = e.target as Shape;
        activeShapes.value = [shape];
        transformer?.nodes([shape]);
        transformer?.moveToTop();
      });
    },
    { immediate: true }
  );

  watch(enable, (enable) => {
    if (!enable) {
      transformer?.nodes([]);
      activeShapes.value = [];
    }
  });

  watch(activeShapes, (shapes) => {
    transformer?.nodes(shapes);
    transformer?.moveToTop();
    if (shapes.length === 0) {
      transformer?.hide();
    } else {
      transformer?.show();
    }
  });

  function clearSelection() {
    activeShapes.value = [];
  }

  return {
    clearSelection,
    transformer,
    activeShapes,
  };
};

export default useMoveAndSelection;
